import { useEffect } from 'react'
import { Platform } from 'react-native'

const SITE_NAME = 'AS Life'

/**
 * Sets the browser tab title (`document.title`) on web — fixes tabs that
 * otherwise fall back to showing the raw URL. Pass the localized page name; the
 * brand suffix is appended automatically ("Новости" → "Новости — AS Life").
 *
 * Pass `null` / `undefined` to skip writing, so a child screen can own the
 * title (the portal layout skips detail routes — `/news/[id]`, `/post/[id]` —
 * letting those screens set the article/post title instead). No-op on native,
 * where there is no browser tab, and SSR-safe for the static web export.
 */
export function useDocumentTitle(title: string | null | undefined) {
  useEffect(() => {
    if (Platform.OS !== 'web' || typeof document === 'undefined') return
    if (title == null) return
    const name = title.trim()
    document.title = name ? `${name} — ${SITE_NAME}` : SITE_NAME
  }, [title])
}
